@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.ss-settings-modal {
  width: 780px;
  height: 420px;
}

.ss-settings-modal-body {
  padding: 15px;
  height: 100%;
}

.ss-settings-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  & > button {
    margin-left: 8px;
  }
}

.subheader {
  padding-bottom: 10px;
  border-bottom: solid 1px @settings-page--shipping-carriers-ss-header--border-color;
  margin-bottom: 10px;
  font-weight: @bold;
}

.label {
  font-size: 14px;
  font-weight: @semi-bold;
  padding: 5px 0;
}

.nickname {
  padding: 10px 0;
  width: 400px;
}

.select-default-checkbox {
  width: 100%;
  display: flex;
}

.select-default-icon {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;

  > svg {
    width: 20px;
    fill: @settings-page--shipping-carriers-ss-checkmark--icon-color;
  }
}

.select-default-checkbox-label {
  color: @settings-page--shipping-carriers-ss-label--text-color;
}

.select-default-label {
  padding-left: 0.5em;
  color: @settings-page--shipping-carriers-ss-label--text-color;
}
